#import '../../fragments/sell.fragment.graphql'

query sellListQuery(
  $limit: Int
  $page: Int
  $filter: String
  $types: [String]
  $fromDate: String
  $toDate: String
) {
  salesData {
    id
    sales(
      limit: $limit
      offset: $page
      filter: $filter
      types: $types
      from: $fromDate
      to: $toDate
    ) {
      id
      list {
        ...SellFragment
      }
      totalRows
    }
  }
}
